import { useRouteState } from '@shared/utils'
import { DeclareClaimRouteState } from './state'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getDateFormatted } from '@shared/utils'
import { Checkmark } from '@carbon/icons-react'
import { useState } from 'react'
import { Button, Spinner } from '@shared/storybook'
import { SRModal } from '@sr/ui'

const TRANSLATION_BASE = 'userArea.monitoringArea.declareClaim'

export const DeclareClaim = observer(() => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [showModal, setShowModal] = useState(false)

  const { policy, declareClaim, isLoading, user } = useRouteState(
    DeclareClaimRouteState,
    { policyId: id },
  )

  const isDeclared = policy?.registryType === 'S'

  if (!user?.isCoordinator) return null

  const handleConfirm = async () => {
    try {
      await declareClaim()
      setShowModal(false)
    } catch (error) {
      console.error('Error declaring claim:', error)
    }
  }

  return (
    <div className="mt-6">
      <p className="text-base font-bold text-secondary mb-4">
        {t(`${TRANSLATION_BASE}.title`)}
      </p>

      <div className="flex items-center gap-4">
        {isDeclared ? (
          <>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-full text-sm font-semibold text-secondary shadow-sm">
              <Checkmark size={16} />
              {t(`${TRANSLATION_BASE}.declared`)}
            </span>
            <span className="text-gray-500 text-sm">
              {t(`${TRANSLATION_BASE}.declaredInfo`, {
                date: getDateFormatted(policy?.registryDate, 'DD/MM/YY'),
                person: policy?.registryBy,
              })}
            </span>
          </>
        ) : (
          <>
            <button
              onClick={() => setShowModal(true)}
              disabled={isLoading}
              className="px-4 py-2 bg-white border border-gray-300 rounded-full text-sm font-semibold text-secondary shadow-sm hover:bg-gray-50 transition-colors disabled:opacity-50"
            >
              {t(`${TRANSLATION_BASE}.declareButton`)}
            </button>
            <span className="text-gray-400 text-sm">
              {t(`${TRANSLATION_BASE}.notDeclared`)}
            </span>
          </>
        )}
      </div>

      {showModal && (
        <SRModal onClose={() => !isLoading && setShowModal(false)}>
          <div className="flex flex-col text-center gap-6">
            <p className="font-bold text-lg">
              {t(`${TRANSLATION_BASE}.confirmModal.title`)}
            </p>
            <p>{t(`${TRANSLATION_BASE}.confirmModal.confirmText`)}</p>
            <p>{t(`${TRANSLATION_BASE}.confirmModal.confirmAreYouSure`)}</p>
            <div className="flex justify-center gap-4">
              {isLoading ? (
                <Spinner variant="circle" />
              ) : (
                <>
                  <Button
                    onClick={() => setShowModal(false)}
                    variant="secondary"
                  >
                    {t('common:cancel')}
                  </Button>
                  <Button onClick={handleConfirm} variant="primary">
                    {t('common:confirm')}
                  </Button>
                </>
              )}
            </div>
          </div>
        </SRModal>
      )}
    </div>
  )
})
